module.exports = __webpack_public_path__ + "static/media/Lucky Number.46e7dfab.jpg";